import { Route } from "react-router-dom";
import lazyRoute from "@/router/lazy-route";

const ClinicalLayoutNew = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/clinical-details/ClinicalLayoutNew")
);
const AllergiesList = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/clinical-details/components/AllergiesList")
);
const CarePlanList = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/clinical-details/components/CarePlanList")
);
const DiagnosisList = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/clinical-details/components/DiagnosisList")
);
const MedicationsList = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/clinical-details/components/MedicationsList")
);
const VaccinesList = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/clinical-details/components/VaccinesList")
);
const VitalsList = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/clinical-details/components/VitalsList")
);

export const PatientChartClinicalRoutes = () => (
  <Route path="clinical-details" element={<ClinicalLayoutNew />}>
    <Route index element={<AllergiesList />} />
    <Route path={"diagnosis"} element={<DiagnosisList />} />
    <Route path={"medications"} element={<MedicationsList />} />
    <Route path={"vaccines"} element={<VaccinesList />} />
    <Route path={"vitals"} element={<VitalsList />} />
    <Route path={"care_plan"} element={<CarePlanList />} />
  </Route>
);
